var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404"},[_c('div',{staticClass:"text"},[_c('h2',[_vm._v("Error")]),_vm._m(0),_c('button',{on:{"click":_vm.goHome}},[_vm._v("Back to Home")])]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('h1',[_vm._v("404")]),_c('h4',[_vm._v("Page not found")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[_c('img',{attrs:{"src":require("@/assets/spidey.png")}})])
}]

export { render, staticRenderFns }